export function preParsePostFormat(string) {
    return string;
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/locale/pre-post-format.js
// module id = 342
// module chunks = 0